var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_Tips"),
        width: "400px",
        "close-on-click-modal": false,
        "show-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticStyle: { display: "flex" } }, [
        _c("div", { staticClass: "el-message-box__status el-icon-success" }),
        _c("div", { staticStyle: { "padding-left": "32px" } }, [
          _c("span", { staticStyle: { "font-size": "20px" } }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ImportingData")))
          ]),
          _c("br"),
          _c("span", { staticStyle: { color: "red" } }, [
            _vm._v(
              _vm._s(_vm.$t("CargoMsg.Cargo_ImportingDataSuccess1")) + " "
            ),
            _c(
              "a",
              {
                staticStyle: { "border-bottom": "1px solid", color: "blue" },
                attrs: { href: "javascript:void(0)" },
                on: { click: _vm.judgePage }
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("CargoMsg.Cargo_ImportingDataSuccess2"))
                )
              ]
            ),
            _vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_ImportingDataSuccess3")))
          ])
        ])
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { no: "cancel" }, on: { click: _vm.cancelHandler } },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }